export default __webpack_public_path__ + "static/media/foto1.479abd24.webp";